import { isPlatformServer } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, filter } from 'rxjs';
import { NavigationItem } from './core/_models/navigation-item';
import { ConfigurationService } from './core/_services/configuration.service';
import { StateService } from './core/_services/state.service';
import { scrollToTop } from './core/_utils/common-function.util';

import * as dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  parentNav?: NavigationItem;
  navItem?: NavigationItem;
  isShowSearch = false;
  lang = `vi`;
  showLoading = false;
  isServer = false;
  subs: Subscription[] = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private _router: Router,
    private _titleService: Title,
    private _activatedRoute: ActivatedRoute,
    private _translate: TranslateService,
    private _stateService: StateService,
    private _configService: ConfigurationService,
  ) {
    this.isServer = isPlatformServer(this.platformId);
    this._stateService.isServer$.next(this.isServer);
    const sub = this._stateService.currentLanguage$.subscribe({
      next: (l: string) => {
        if (this.isServer) {
          // Todo
        } else {
          localStorage.setItem('LANGUAGE', l);
        }
        this.lang = l;
        this._translate.setDefaultLang(l);
        this._translate.use(l);
        this._configService.getAllConfiguration();
        dayjs.locale(l);
        scrollToTop();
      },
    });
    this.subs.push(sub);
    const sub2 = this._router.events.subscribe((val) => {
      // see also
      if (val instanceof NavigationStart) {
        this.showLoading = true;
        setTimeout(() => {
          this.showLoading = false;
        }, 400);
      }
    });
    this.subs.push(sub2);
  }

  ngAfterViewInit(): void {
    this._configService.isMobile = window.innerWidth < 768 ? true : false;
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  showSearchChange(isShowSearch: boolean) {
    this.isShowSearch = isShowSearch;
  }

  async ngOnInit() {
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const rt = this._getChild(this._activatedRoute);
      rt.data.subscribe(async (data) => {
        const [_c] = await this._configService.getAllConfiguration();
        const _t = `${data['title']} | ${_c?.name} - ${_c?.slogan}`;
        this._titleService.setTitle(_t);
      });
    });
  }

  private _getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.firstChild) {
      return this._getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
